module.exports = __webpack_public_path__ + "img/who-search.6e065d2e.png";